import { render } from "./ModalView.vue?vue&type=template&id=a51ac64a"
import script from "./ModalView.vue?vue&type=script&lang=js"
export * from "./ModalView.vue?vue&type=script&lang=js"

import "./ModalView.vue?vue&type=style&index=0&id=a51ac64a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__